import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, PrizeDrawsData, PrizeDrawDetail } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: { totalCount: 0 },
  },
  currentDraw: null,
};

const prizeDrawsSlice = createSlice({
  name: 'prizeDraws',
  initialState,
  reducers: {
    setPrizeDrawsData(state: initState, action: PayloadAction<{ list: PrizeDrawsData }>) {
      state.list = action.payload.list;
    },
    setCurrentDraw(state: initState, action: PayloadAction<PrizeDrawDetail | null>) {
      state.currentDraw = action.payload;
    },
  },
});

export const { setPrizeDrawsData, setCurrentDraw } = prizeDrawsSlice.actions;

export default prizeDrawsSlice.reducer;
